import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.658 13.017s1.316.715 1.974 1.762c0 0 1.974-4.112 4.606-5.483",
      class: "path",
      color: "currentColor",
      style: {"stroke-width":"1.64488"},
      transform: "matrix(1.31832 0 0 1.34413 -7.493 -8.04)"
    }, null, -1)
  ])))
}
export default { render: render }